import { Button, Modal } from 'native-base';
import React, { useState } from 'react';
import { Icon } from '../../Common/components/Icon';
import { faBookMedical } from '@fortawesome/pro-solid-svg-icons/faBookMedical';
import { DoctorMedicareOverviewModal } from './DoctorMedicareOverviewModal';

interface IDoctorMedicareOverviewProps {
  customerID: string;
  onLoadDocumentCLicked: (documentID: string, repositoryID: string | null | undefined) => void;
}
export function DoctorMedicareOverview({ customerID, onLoadDocumentCLicked }: IDoctorMedicareOverviewProps) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        leftIcon={<Icon icon={faBookMedical} />}
        size={'sm'}
        variant={'outline'}
        onPress={() => setShowModal(true)}
      >
        My Health Record - Medicare Summary
      </Button>

      <Modal isOpen={showModal} size={'full'} onClose={() => setShowModal(false)}>
        {showModal && <DoctorMedicareOverviewModal customerID={customerID} onLoadDocumentCLicked={onLoadDocumentCLicked} />}
      </Modal>
    </>
  );
}
